module.exports = __webpack_public_path__ + "img/brand_templates_illustration.1f2dc73c.svg";